/**
 * هشدارهای پیش از ثبتِ سند/پرداخت/انتقال (v2.173.0).
 *
 * کاربر (۱۴۰۵/۰۸/۱۲): «دوبرابر نشه، چیزی کم نباشه، چیزی زیاد شد مشخص بشه». سرور (`/finance/check-entry`) می‌سنجد:
 * مبلغِ غیرعادی (صفرِ اضافه)، سندِ تکراری، پرداختِ بیش از طلبِ حقوق، و اسمِ همکار در شرحِ سندِ یک‌طرفه
 * (باید «انتقال بین پرسنل» می‌بود). هیچ‌کدام مانع نیست — کاربر می‌بیند و «با این حال ثبت کن» می‌زند.
 * اگر بررسی خودش خطا داد، ثبت را نگه نمی‌داریم (فقط هشدار است).
 */
import React from "react";
import { Modal } from "antd";
import { checkFinanceEntry } from "../api/client";

export default async function confirmEntry(body) {
  let warnings = [];
  try {
    const r = await checkFinanceEntry(body);
    warnings = r.data?.warnings || [];
  } catch {
    return true;
  }
  if (!warnings.length) return true;
  const hard = warnings.some((w) => w.level === "error");
  return new Promise((resolve) => {
    Modal.confirm({
      title: hard ? "این ثبت احتمالاً اشتباه است" : "پیش از ثبت ببینید",
      width: 520,
      okText: "با این حال ثبت کن",
      okButtonProps: { danger: hard },
      cancelText: "برگرد و اصلاح کن",
      content: (
        <ul style={{ paddingInlineStart: 18, margin: 0 }}>
          {warnings.map((w) => (
            <li key={w.code} style={{ marginBottom: 6 }}>
              <b style={{ color: w.level === "error" ? "#C0392B" : "#B9770E" }}>{w.label}:</b> {w.text}
            </li>
          ))}
        </ul>
      ),
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}
